import React from 'react';

const AIMarketing = ({ language = 'en' }) => {
  const content = {
    en: {
      title: 'AI Smart Marketing & Digital Screen',
      subtitle: 'AI Smart Marketing & Digital Screen Media',
      intro: [
        'We specialize in AI-powered smart marketing and digital screen media services. Centered on AI large models and big data technology, we integrate offline digital screen networks to build an integrated online-offline smart marketing ecosystem.',
        'Our digital screens cover residential buildings, lobbies, elevators, shopping malls and public venues. Clients can leverage AI models, cloud management systems and connected screens to enjoy one-stop services including intelligent content creation, precise advertising, real-time data monitoring and operational monetization.',
        'We are committed to delivering cost-effective, high-conversion, flexible and efficient marketing solutions for our partners, and jointly creating new value in the digital business era.'
      ]
    },
    zh: {
      title: 'AI智能營銷與電子屏幕媒體',
      subtitle: '智能營銷與電子屏幕媒體',
      intro: [
        '我們專注發展AI智能營銷與電子屏幕媒體業務，以人工智能大模型及大數據技術為核心，結合線下電子屏幕矩陣，打造「線上+線下」一體化智慧營銷生態。',
        '我們的電子屏幕覆蓋社區、大廈大堂、電梯、商場及公眾場所等多元場景，客戶可透過AI大模型、雲端管理系統與全域屏幕聯動，享受智能內容製作、精準廣告投放、實時數據監測及營運變現一站式服務。',
        '我們致力為合作夥伴帶來更低成本、更高轉化、更靈活高效的營銷與媒體運營方案，攜手共創數字商業新價值。'
      ]
    }
  };

  const currentContent = content[language] || content.en;

  return (
    <section id="ai-marketing" className="service__section pt-120 pb-120">
      <div className="container">
        <div className="project__head text-center mb-60">
          <span className="common__sub aos-init aos-animate" data-aos="fade-down" data-aos-duration="1000">
            {currentContent.title}
          </span>
          <h2 className="fw-500 aos-init aos-animate" data-aos="fade-up" data-aos-duration="1200" style={{ color: '#c9f31d' }}>
            {currentContent.subtitle}
          </h2>
        </div>

        <div style={{ maxWidth: '1000px', margin: '0 auto' }}>
          {/* Hero Image */}
          <div style={{ position: 'relative', zIndex: 1, borderRadius: '12px', overflow: 'hidden', marginBottom: '2rem' }}>
            <img
              src="/assets/photos/ai-marketing.jpeg"
              alt="AI Smart Marketing & Digital Screen Media"
              style={{ width: '100%', height: 'auto', display: 'block', borderRadius: '12px' }}
            />
          </div>
          {/* Intro */}
          <div
            className="aos-init aos-animate"
            data-aos="fade-up"
            data-aos-duration="1000"
            style={{
              background: 'rgba(255, 255, 255, 0.03)',
              padding: '2.5rem',
              borderRadius: '12px',
              border: '1px solid rgba(255, 255, 255, 0.1)',
              marginBottom: '2rem',
              transition: 'all 0.3s ease'
            }}
          >
            {currentContent.intro.map((para, idx) => (
              <p key={idx} className="pra fz-18" style={{
                lineHeight: '1.9',
                color: '#e0e0e0',
                textAlign: 'justify',
                margin: idx < currentContent.intro.length - 1 ? '0 0 1.2rem 0' : '0'
              }}>
                {para}
              </p>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AIMarketing;
